import React from 'react';

const DefaultTypeBoolean = props => {
  const { data, schema, path = [] } = props;
  return (
    <div className={`default-type-boolean depth-${path.length}`}>
      <strong className="default-type-boolean-title">{schema.title}</strong>{' '}
      <span className="default-type-boolean-value">{data}</span>
    </div>
  );
};

export default DefaultTypeBoolean;
